import { createElement } from "react";
import { IconSvg, type IconSvgProps } from "@contra/icons/icons";
export const OnboardingPlaceholderIcon = (props: IconSvgProps) =>
  createElement(
    IconSvg,
    {
      ...props,
      viewBox: "0 0 176 176",
    },
    <path
      fill="#F7F7F7"
      fillRule="evenodd"
      d="M88 176c48.601 0 88-39.399 88-88S136.601 0 88 0 0 39.399 0 88s39.399 88 88 88"
      clipRule="evenodd"
    />,
    <mask
      id="onboarding-placeholder_svg__a"
      width={176}
      height={176}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M88 176c48.601 0 88-39.399 88-88S136.601 0 88 0 0 39.399 0 88s39.399 88 88 88"
        clipRule="evenodd"
      />
    </mask>,
    <g fill="#2F2F2F" mask="url(#onboarding-placeholder_svg__a)">
      <path
        fillRule="evenodd"
        d="M88.106 108.778c20.985 0 37.996-16.964 37.996-37.89C126.102 49.964 109.091 33 88.106 33c-20.984 0-37.995 16.963-37.995 37.889 0 20.925 17.011 37.889 37.995 37.889"
        clipRule="evenodd"
        opacity={0.06}
      />
      <rect
        width={132}
        height={74.556}
        x={22}
        y={117.333}
        opacity={0.06}
        rx={37.278}
      />
    </g>
  );
